import { Component, Inject } from '@angular/core'
import { BasePanelComponent, LayoutContainer } from '@helios/panel-base'
import { ComponentContainer } from 'golden-layout'

interface GettingStartedState {
  prop: string // TODO replace this with your panel's state object
}

@Component({
  selector: 'hs-getting-started',
  templateUrl: './getting-started-panel.component.html',
  styleUrls: ['./getting-started-panel.component.scss'],
})
export class GettingStartedPanelComponent extends BasePanelComponent<GettingStartedState> {
  constructor(@Inject(LayoutContainer) container: ComponentContainer) {
    super(container)
  }
}
